import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import {privacyPolicy, termsOfUse} from '../../content/legalContent';

const legalPages = {
  terms: {
    eyebrow: 'Website terms',
    title: 'Terms of Use',
    intro: 'Please read these terms before using this website.',
    sections: termsOfUse,
  },
  privacy: {
    eyebrow: 'Your information',
    title: 'Privacy Policy',
    intro: 'This policy describes the public informational website.',
    sections: privacyPolicy,
  },
};

const LegalPage = ({type}) => {
  const page = legalPages[type] || legalPages.terms;

  return (
    <main className="min-h-screen bg-cream px-6 py-12 md:py-20">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-warm-brown/75 hover:text-warm-brown transition-colors mb-10"
        >
          <span aria-hidden="true">←</span>
          Back to La Vie Saigon
        </Link>

        <motion.article
          initial={{opacity: 0, y: 18}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.45}}
          className="bg-white rounded-2xl shadow-lg p-6 md:p-12"
        >
          <p className="uppercase tracking-[0.25em] text-gold-accent text-sm mb-3">
            {page.eyebrow}
          </p>
          <h1 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-3">
            {page.title}
          </h1>
          <p className="text-warm-brown/70 mb-8">{page.intro}</p>

          <div>
            {page.sections.map((section) => (
              <section key={section.title} className="border-t border-warm-brown/10 py-6">
                <h2 className="font-playfair text-xl text-warm-brown mb-2">
                  {section.title}
                </h2>
                <p className="text-warm-brown/75 leading-relaxed">{section.text}</p>
              </section>
            ))}
          </div>

          <nav aria-label="Legal pages" className="border-t border-warm-brown/10 pt-6 flex flex-wrap gap-5">
            <Link to="/terms-of-use" className="text-warm-brown underline underline-offset-4">
              Terms of Use
            </Link>
            <Link to="/privacy-policy" className="text-warm-brown underline underline-offset-4">
              Privacy Policy
            </Link>
          </nav>
        </motion.article>
      </div>
    </main>
  );
};

export default LegalPage;